/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Outlook_No_Messages_DescriptionInputs */



/**
* | output |
* | --- |
* | "This folder has no synced messages yet." |
*
* @param {Spaces_Outlook_No_Messages_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_outlook_no_messages_description = /** @type {((inputs?: Spaces_Outlook_No_Messages_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Outlook_No_Messages_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Ordner enthält noch keine synchronisierten Nachrichten.")
	return /** @type {LocalizedString} */ ("This folder has no synced messages yet.")
});